// Client-side filter for the Novedades grid — instant, no reload.

document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('[data-novedades-grid]')
  if (!grid) return

  const buttons = document.querySelectorAll('.novedades-filter')
  const cards = grid.querySelectorAll('.novedad-card')
  const emptyMsg = document.querySelector('[data-novedades-empty]')

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const filter = btn.dataset.filter

      // Toggle button states
      buttons.forEach((b) => {
        b.classList.toggle('is-active', b === btn)
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false')
      })

      // Toggle cards
      let visible = 0
      cards.forEach((card) => {
        const match = filter === 'all' || card.dataset.category === filter
        card.classList.toggle('is-hidden', !match)
        if (match) visible++
      })

      // Empty state
      if (emptyMsg) {
        emptyMsg.hidden = visible !== 0
      }
    })
  })
})
